module.exports = __webpack_public_path__ + "img/12.d2c507fd.png";